import { API_URL } from "../Config/config.js";
import axiosInstance from './axiosInstance.js';


const getOrderList = async (params) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await axiosInstance.get(API_URL + "order/getallorders", { params });
    return {
      status: true,
      data: response.data.data.rows,
      totalCount: response.data.data.count,
      pagination: response.data.data.pagination,
      statusCount: response.data.data.statusCount || [],
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const getSkuOrderList = async (params) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await axiosInstance.get(API_URL + "order/getskuorder-list", { params });
    
    return {
      status: true,
      data: response.data.data.rows,
      totalCount: response.data.data.count,
      pagination: response.data.data.pagination,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const getSkuOrderItemList = async (params) => {
  try {
    const response = await axiosInstance.get(API_URL + "order/getskuorder-item", { params });
    // console.log(response);
    
    return {
      status: true,
      data: response.data.data.rows,
      totalCount: response.data.data.count,
      pagination: response.data.data.pagination,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const approvedOrder = async (body) => {
  try {
    const response = await axiosInstance.patch(API_URL + "order/update-status-order", body);
    // console.log("approvedOrderapprovedOrder",response);
    return {
      status: true,
      data: response.data?.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const updateOrder = async (body) => {
  try {
    const response = await axiosInstance.patch(API_URL + "order/update-order", body);
    // console.log("approvedOrderapprovedOrder",response);
    return {
      status: true,
      data: response.data?.data,
      message: response.data?.message,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const orderDownloadAdmin = async (filter) => {
  try {
      const params = new URLSearchParams();

      if (filter?.user_id) params.append("user_id", filter.user_id);
      if (filter?.order_id) params.append("order_id", filter.order_id);
      if (filter?.mobile) params.append("mobile", filter.mobile);
      if (filter?.distributor_name) params.append("distributor_name", filter.distributor_name);
      if (filter?.lrnoAndInvoiceSearch) params.append("lrnoAndInvoiceSearch", filter.lrnoAndInvoiceSearch);
      if (filter?.region_id) params.append("region_id", filter.region_id);
      if (filter?.state_id) params.append("state_id", filter.state_id);
      if (filter?.district_id) params.append("district_id", filter.district_id);
      if (filter?.date_type) params.append("date_type", filter.date_type);
      if (filter?.start_date) params.append("start_date", filter.start_date);
      if (filter?.end_date) params.append("end_date", filter.end_date);
      if (filter?.zonal_manager_id) params.append("zonal_manager_id", filter.zonal_manager_id);

      let URL = `${API_URL}order/order-admin-overview-download?${params.toString()}`;
      
      if (filter?.status_id) {
        const statusArray = Array.isArray(filter.status_id) ? filter.status_id : [filter.status_id];
        console.log(statusArray, 'statusArray')
        statusArray.forEach(status => URL += `&status_id[]=${status}`); 
      }
      
      const response = await axiosInstance.get(URL);

      return {status: true, data: response.data}
  } catch (err) {
      return { status: false, data: err.response };
  }
}

const orderDownloadDist = async (filter) => {
  try {
      const params = new URLSearchParams();

      if (filter?.user_id) params.append("user_id", filter.user_id);
      if (filter?.order_id) params.append("order_id", filter.order_id);
      if (filter?.mobile) params.append("mobile", filter.mobile);
      if (filter?.distributor_name) params.append("distributor_name", filter.distributor_name);
      if (filter?.lrnoAndInvoiceSearch) params.append("lrnoAndInvoiceSearch", filter.lrnoAndInvoiceSearch);
      if (filter?.region_id) params.append("region_id", filter.region_id);
      if (filter?.state_id) params.append("state_id", filter.state_id);
      if (filter?.district_id) params.append("district_id", filter.district_id);
      if (filter?.date_type) params.append("date_type", filter.date_type);
      if (filter?.start_date) params.append("start_date", filter.start_date);
      if (filter?.end_date) params.append("end_date", filter.end_date);
      

      let URL = `${API_URL}order/order-overview-download?${params.toString()}`;

      if (filter?.status_id) {
        const statusArray = Array.isArray(filter.status_id) ? filter.status_id : [filter.status_id];
        console.log(statusArray, 'statusArray')
        statusArray.forEach(status => URL += `&status_id[]=${status}`); 
      }

      const response = await axiosInstance.get(URL);

      return {status: true, data: response.data}
  } catch (err) {
      return { status: false, data: err.response };
  }
}

const confirmOrder = async (body) => {
  try {
    const response = await axiosInstance.put(API_URL + "order/confirm-order", body);
    // console.log("approvedOrderapprovedOrder",response);
    return {
      status: true,
      data: response.data?.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const deleteOrder = async (body) => {
  try {
    const response = await axiosInstance.delete(API_URL + "order/delete-order", {data: body});
    return {
      status: true,
      data: response.data?.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const updateOrderInvoiceNumber = async (body) => {
  try {
    const response = await axiosInstance.put(API_URL + "order/update-invoice", body);
    // console.log("approvedOrderapprovedOrder",response);
    return {
      status: true,
      data: response.data?.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const holdOrder = async (body) => {
  try {
    const response = await axiosInstance.put(API_URL + "order/hold-order", body);
    // console.log("approvedOrderapprovedOrder",response);
    return {
      status: true,
      data: response.data?.data,
      message : response?.data?.message
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const deleteSku = async (body) => {
  try {
    const response = await axiosInstance.delete(API_URL + "order/delete-sku-order", {data: body});
    console.log("approvedOrderapprovedOrder service",response);
    return {
      status: true,
      data: response.data?.data,
      message : response?.data?.message
    }
  } catch(err) {
    console.log(err, 'error in service');
      return {
        status: false,
        message: err.response.data.message,
        code: err.response.data.code,
      };
  }
}

const releaseOrder = async (body) => {
  try {
    const response = await axiosInstance.put(API_URL + "order/release-order", body);
    // console.log("approvedOrderapprovedOrder",response);
    return {
      status: true,
      data: response.data?.data,
      message : response?.data?.message
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const getZonalList = async (id=null) => {
  let url = API_URL + "zoneManager/zone";

  if (id) {
    url += `?region_id=${id}`;
  }
  try {
    const response = await axiosInstance.get(url);
    return {
      status: true,
      data: response.data.data.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const getDistiributorlList = async () => {
  const user = JSON.parse(localStorage.getItem("user"));
  try {
    const response = await axiosInstance.get(API_URL + `distributor/getDistributorsByZonalManager?user_id=${user?.userDataObj?.user_id}`);
    return {
      status: true,
      data: response.data.data.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

const getDownLoadList = async (params) => {
  try {
    const response = await axiosInstance.get(API_URL + "order/download-list", { params });
    return {
      status: true,
      data: response.data.data,
      totalCount: response.data?.count,
      pagination: response.data?.pagination,
    };
  } catch (err) {
    return {
      status: false,
      message: err.response.data.message,
      code: err.response.data.code,
    };
  }
};

export default {
    getOrderList,
    getSkuOrderList,
    getSkuOrderItemList,
    approvedOrder,
    updateOrder,
    confirmOrder,
    deleteOrder,
    updateOrderInvoiceNumber,
    holdOrder,
    releaseOrder,
    orderDownloadAdmin,
    orderDownloadDist,
    deleteSku,
    getDownLoadList,
    getZonalList,
    getDistiributorlList
}